import { ReactNode, useMemo } from 'react'
import { TableOfContents } from '@/components/TableOfContents'
import { authors } from '@/authors'
import {
  ArticleContainer,
  PostContainer,
} from '@/components/marketing/Containers'

import clsx from 'clsx'
import { BlogMeta } from '@/types/blog'

interface TableOfContentsItem {
  id: string
  title: string
  url: string
  children: TableOfContentsItem[]
}

interface PageLayoutProps {
  children: ReactNode
  tableOfContents: TableOfContentsItem[]
  blogMeta: BlogMeta
}

export function PageLayout({
  children,
  tableOfContents,
  blogMeta,
}: PageLayoutProps) {
  const _hideTableOfContents = blogMeta.hideTableOfContents ?? false
  const hideTableOfContents =
    tableOfContents.length == 0 || _hideTableOfContents
  const containerWidth = hideTableOfContents ? 'max-w-6xl' : 'max-w-8xl'

  const authorsData = useMemo(() => {
    const authorNames = blogMeta.authorNames || []
    return authorNames.map(
      (author_name: string) => authors[author_name as keyof typeof authors]
    )
  }, [blogMeta.authorNames])

  blogMeta.authors = authorsData ?? []

  return (
    <>
      <PostContainer className={clsx('my-16', containerWidth)}>
        <div className="min-w-0 max-w-5xl flex-auto px-4 py-0 lg:pl-8 lg:pr-0 xl:px-14">
          <ArticleContainer blogMeta={blogMeta} proseChildren={children} />
        </div>

        {!hideTableOfContents && (
          <TableOfContents tableOfContents={tableOfContents} />
        )}
      </PostContainer>

      <PostContainer className="max-w-8xl overflow-hidden">
        <div className="min-w-0 flex-auto px-4 py-0 lg:pl-8 lg:pr-0 xl:px-14"></div>
      </PostContainer>
    </>
  )
}
